import { Button, DatePicker, Input, Select, Space, Tag, message } from 'antd'
import dayjs from 'dayjs'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import React from 'react'
import { Text } from '../../../../styles/reactnative'
import API from '../../../../utils/api'
import ExchangeName from '../../ExchangeName'
import Price from '../../PositionColumns/Price'
import SSlipage from 'app/components/SSlipage'

export const column_pairs_status = (
	mutate,
	usermodal,
	token,
	fold,
	edit,
	setEdit,
	shareMutate
) => {
	let editable = false
	const decodedToken: any = jwtDecode(token + '')
	const level = decodedToken?.level || null

	return [
		{
			title: '순서',
			dataIndex: 'ord',
			key: 'ord',
			align: 'center',
			width: 70,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '구분코드',
			dataIndex: 'code',
			align: 'center',
			key: 'code',
			width: 80,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '구분이름',
			dataIndex: 'groupname',
			key: 'groupname',
			align: 'center',
			render: (text, record) => {
				return record?.edit ? (
					<Input
						size="small"
						defaultValue={text}
						onChange={e => {
							record.adminname = e.target.value
						}}
					/>
				) : (
					<Text style={{ fontWeight: 'bold' }}>{text}</Text>
				)
			},
		},
		{
			title: '거래소',
			dataIndex: 'exchange_id',
			align: 'center',
			key: 'exchange_id',
			render: (text, record) => {
				return <ExchangeName exchange_id={text} />
			},
		},
		{
			title: '종목코드',
			dataIndex: 'pairs',
			key: 'pairs',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '종목이름',
			align: 'center',
			dataIndex: 'name',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '증거금',
			align: 'center',
			children: [
				{
					title: '증거금',
					dataIndex: 'minimum_margin',
					align: 'center',
					key: 'minimum_margin',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.minimum_margin = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '로스컷',
					dataIndex: 'losscut',
					align: 'center',
					key: 'losscut',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.losscut = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '오버나잇',
					dataIndex: 'ovn_margin',
					align: 'center',
					key: 'ovn_margin',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.ovn_margin = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '최대계약수',
					dataIndex: 'max_amount',
					align: 'center',
					key: 'max_amount',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.max_amount = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
			],
		},
		{
			title: '수수료',
			align: 'center',
			children: [
				{
					title: '수수료',
					dataIndex: 'fee',
					align: 'right',
					key: 'fee',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.fee = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
				{
					title: '단위',
					dataIndex: 'feetype',
					align: 'left',
					width: 80,
					key: 'feetype',
					render: (text, record) => {
						return record?.edit ? (
							<Select
								defaultValue={text}
								size="small"
								options={[
									{ value: 0, label: '%' },
									{ value: 1, label: record?.feecurrency },
								]}
								onChange={e => {
									record.feetype = e
								}}
							/>
						) : (
							<Text>{text == 0 ? '%' : record?.feecurrency}</Text>
						)
					},
				},
			],
		},
		{
			title: `상장일 (오늘날짜${moment().format('MM-DD')})`,
			children: [
				{
					title: '상장일',
					dataIndex: 'startdate',
					align: 'center',
					key: 'startdate',
					render: (text, record) => {
						return record?.edit ? (
							<DatePicker
								size="small"
								onChange={e => {
									record.startdate = e?.format('YYYY-MM-DD')
								}}
								defaultValue={dayjs(
									record?.startdate,
									'YYYY-MM-DD'
								)}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
				{
					title: '만료일',
					dataIndex: 'enddate',
					align: 'center',
					key: 'enddate',
					render: (text, record) => {
						return record?.edit ? (
							<DatePicker
								size="small"
								onChange={e => {
									record.enddate = e?.format('YYYY-MM-DD')
								}}
								defaultValue={dayjs(
									record?.enddate,
									'YYYY-MM-DD'
								)}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
			],
		},
		{
			title: '슬리피지',
			dataIndex: 'slippage',
			align: 'center',
			key: 'slippage',
			render: (text, record) => {
				return <SSlipage ep_id={record.id} />
			},
		},
		{
			title: '상태',
			dataIndex: 'openstatus',
			align: 'center',
			render: (text, record) => {
				return (
					<Tag color={text == 1 ? 'green' : 'red'}>
						{text == 1
							? '운영중'
							: text == 4
							? '월물만료'
							: text == 3
							? '강제중지'
							: '장마감'}
					</Tag>
				)
			},
		},
		{
			title: '상태변경',
			dataIndex: 'openstatus',
			align: 'center',
			render: (text, record) => {
				return (
					<Space>
						{/* <Space.Compact>
							<Button
								size="small"
								color="red"
								type="primary"
								onClick={() => {
									API.post(`/admin/orchange`, token, {
										id: record.id,
										type: 0,
									}).then(res => {
										if (res.result.success) {
											mutate()
										} else {
											message.error(res.data.msg)
										}
									})
								}}>
								↑
							</Button>
							<Button
								size="small"
								color="red"
								type="primary"
								onClick={() => {
									API.post(`/admin/orchange`, token, {
										id: record.id,
										type: 1,
									}).then(res => {
										if (res.result.success) {
											mutate()
										} else {
											message.error(res.data.msg)
										}
									})
								}}>
								↓
							</Button>
						</Space.Compact> */}
						<Button
							size="small"
							color="red"
							type="primary"
							onClick={() => {
								API.post(`/admin/epstatus`, token, {
									id: record.id,
									status: 1,
								}).then(res => {
									if (res.result.success) {
										message.success('오픈되었습니다.')
										mutate()
									} else {
										message.error(res.data.msg)
									}
								})
							}}>
							운영
						</Button>
						<Button
							size="small"
							danger
							type="primary"
							onClick={() => {
								API.post(`/admin/epstatus`, token, {
									id: record.id,
									status: 3,
								}).then(res => {
									if (res.result.success) {
										message.success('정지되었습니다.')
										mutate()
									} else {
										message.error(res.data.msg)
									}
								})
							}}>
							정지
						</Button>
						{level == 99 ? (
							<>
								<Button
									size="small"
									danger
									type="primary"
									onClick={() => {
										API.post(`/admin/epstatus`, token, {
											id: record.id,
											status: 2,
										}).then(res => {
											if (res.result.success) {
												message.success(
													'정지되었습니다.'
												)
												mutate()
											} else {
												message.error(res.data.msg)
											}
										})
									}}>
									장마감
								</Button>
								<Button
									size="small"
									danger
									type="primary"
									onClick={() => {
										API.post(`/admin/epstatus`, token, {
											id: record.id,
											status: 4,
										}).then(res => {
											if (res.result.success) {
												message.success(
													'만료되었습니다.'
												)
												mutate()
											} else {
												message.error(res.data.msg)
											}
										})
									}}>
									만료
								</Button>
							</>
						) : (
							<Button
								size="small"
								danger
								type="primary"
								onClick={() => {
									API.post(`/admin/epstatus`, token, {
										id: record.id,
										status: 4,
									}).then(res => {
										if (res.result.success) {
											message.success('만료되었습니다.')
											mutate()
										} else {
											message.error(res.data.msg)
										}
									})
								}}>
								삭제
							</Button>
						)}
					</Space>
				)
			},
		},
	]
}
